import ROUTE from '@app/navigationApp/routes';
import { ThemedPressable, ThemedText, ThemedView } from '@app/theme';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Image, Pressable, StyleSheet, Text, View } from 'react-native';

const ElevateHomeCardTata = ({navigation}) => {

  const navigateToElevateLanding = () => {
     AsyncStorage.setItem('isElevate',"true" )

    navigation.navigate(ROUTE.ELEVATE_LANDING);

  }

  return (
    <ThemedPressable onPress={navigateToElevateLanding}  flexDirection='row' borderRadius='lg' backgroundColor="bg-action-primary" overflow='hidden' mx="lg"  mt="lg">
      <ThemedView pl="md" pb="2xl" pt="lg" flex={1}>
        <ThemedText variant='b2s' color="white" mb="sm">Elevate your loan experience</ThemedText>
        <ThemedText variant='b4r' color="chalk">
          Unlocking the value of your mutual funds in a few clicks with DSP Finance!
        </ThemedText>
      </ThemedView>
      <Image
        style={styles.coinImage}
        source={{
          uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/elevate_home_card_coin.png',
        }}
      />
      <Image
        style={styles.bgImage}
        source={{
          uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/elevate_home_card_bg.png',
        }}
      />
    </ThemedPressable>
  );
};

export default ElevateHomeCardTata;


// Todo: Use new theme while revamping
const styles = StyleSheet.create({
  coinImage: {
    height: 95,
    width: 95,
    alignSelf: 'flex-end',
  },
  bgImage: {
    height: '100%',
    width: 120,
    alignSelf: 'flex-end',
    position: 'absolute',
    right: 0,
  },
});
